module.exports = __webpack_public_path__ + "static/media/tutorial-excercise-pin.3cb8674f.svg";